"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.getViewersState = exports.getIssueViewers = exports.fetchIssueViewersByIdAction = exports.STATE_KEY = void 0;
var _fetchHelpers = require("../fetchHelpers");
var _toolkit = require("@reduxjs/toolkit");
const STALENESS_THRESHOLD = 5; // Number of issue viewers to save

const initialState = {
  viewersMap: {},
  requestHistory: []
};
const issuesViewersSlice = (0, _toolkit.createSlice)({
  name: "viewers",
  reducers: {
    issueViewersFetchByIdStart: (state, action) => {
      // Remove stale entries
      while (state.requestHistory.length >= STALENESS_THRESHOLD) {
        const oldestRequestId = state.requestHistory.shift();
        if (oldestRequestId && state.viewersMap[oldestRequestId].status !== _fetchHelpers.FetchStatus.Loading) {
          delete state.viewersMap[oldestRequestId];
        }
      }
      state.viewersMap[action.payload.issueId] = {
        status: _fetchHelpers.FetchStatus.Loading
      };
    },
    issueViewersFetchByIdFailure: (state, action) => {
      state.viewersMap[action.payload.issueId].status = _fetchHelpers.FetchStatus.Error;
    },
    issueViewersFetchByIdSuccess: (state, action) => {
      const {
        issueId,
        data
      } = action.payload;
      state.viewersMap[issueId].data = data;
      state.viewersMap[issueId].status = _fetchHelpers.FetchStatus.Success;
      state.requestHistory.push(issueId);
    }
  },
  initialState
});
const reducer = exports.reducer = issuesViewersSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issuesViewersSlice.name;
const getViewersState = state => state[STATE_KEY];
exports.getViewersState = getViewersState;
const {
  issueViewersFetchByIdStart,
  issueViewersFetchByIdFailure,
  issueViewersFetchByIdSuccess
} = issuesViewersSlice.actions;
const fetchIssueViewersByIdAction = _ref => {
  let {
    issueId,
    forceFetch = false
  } = _ref;
  return async (dispatch, getState, _ref2) => {
    let {
      sdk
    } = _ref2;
    const {
      viewersMap
    } = getViewersState(getState());
    if (viewersMap[issueId] && viewersMap[issueId].status !== _fetchHelpers.FetchStatus.Error && !forceFetch) {
      return;
    }
    dispatch(issueViewersFetchByIdStart({
      issueId
    }));
    let response = undefined;
    try {
      response = await sdk.IssueViewers.get(issueId);
    } catch {
      dispatch(issueViewersFetchByIdFailure({
        issueId
      }));
      return;
    }
    dispatch(issueViewersFetchByIdSuccess({
      issueId,
      data: response
    }));
  };
};
exports.fetchIssueViewersByIdAction = fetchIssueViewersByIdAction;
const getIssueViewers = state => issueId => {
  const viewersState = getViewersState(state);
  if (!issueId || !viewersState.viewersMap[issueId]) {
    return undefined;
  }
  const {
    data
  } = viewersState.viewersMap[issueId];
  return data;
};
exports.getIssueViewers = getIssueViewers;
//# sourceMappingURL=issuesViewers.js.map